import React, { useEffect } from "react";
import EditorRail from "./EditorRail";
import EditorHeader from "./EditorHeader";
import EditorFooter from "./EditorFooter";
import SlideOver from "./SlideOver";

const PANEL_LABELS = {
	templates: "Modèles",
	exercices: "Exercices",
	calendrier: "Calendrier",
	"student-programmes": "Ses programmes",
};

const PANEL_DESCRIPTIONS = {
	templates: "Arborescence de dossiers + cartes modèles",
	exercices: "Recherche + filtres par muscle",
	calendrier: "Vue mois + agenda à venir",
	"student-programmes": "Programmes en cours + historique de l'élève",
};

export default function EditorShell({
	user,
	studentName,
	students = null,
	currentStudentId = null,
	onSwitchStudent = null,
	trainingName,
	isTemplate,
	editorMode,
	lastModifiedAt,
	savingTraining,
	canDelete,
	canSave,
	hasTraining = false,
	onExit,
	onOpenSearch,
	onHistorique,
	onDupliquer,
	onConsignes = null,
	consignesBloquees = false,
	onSave,
	onSaveAsTemplate,
	onDelete,
	onCancel,
	activePanel,
	setActivePanel,
	panels = {},
	navItems,
	hasActions = true,
	headerExtra = null,
	children,
}) {
	useEffect(() => {
		const onKey = (e) => {
			if (e.key === "Escape" && activePanel) {
				setActivePanel(null);
			}
		};
		window.addEventListener("keydown", onKey);
		return () => window.removeEventListener("keydown", onKey);
	}, [activePanel, setActivePanel]);

	const handleToggle = (key) => {
		setActivePanel((prev) => (prev === key ? null : key));
	};

	const renderPanelContent = () => {
		if (!activePanel) return null;
		const Custom = panels[activePanel];
		if (Custom) return Custom;
		return (
			<div className="editor-panel-placeholder">
				<div className="editor-panel-placeholder-icon">🚧</div>
				<h3>{PANEL_LABELS[activePanel] || activePanel}</h3>
				<p>{PANEL_DESCRIPTIONS[activePanel] || ""}</p>
				<p className="editor-panel-placeholder-status">Disponible en Phase 2</p>
			</div>
		);
	};

	return (
		<div className="editor-shell">
			<EditorRail
				activePanel={activePanel}
				onTogglePanel={handleToggle}
				user={user}
				onExit={onExit}
				items={navItems}
			/>

			<div className="editor-shell-main">
				<EditorHeader
					studentName={studentName}
					students={students}
					currentStudentId={currentStudentId}
					onSwitchStudent={onSwitchStudent}
					trainingName={trainingName}
					isTemplate={isTemplate}
					hasTraining={hasTraining}
					hasActions={hasActions}
					onHistorique={onHistorique}
					onDupliquer={onDupliquer}
					onConsignes={onConsignes}
					consignesBloquees={consignesBloquees}
					headerExtra={headerExtra}
				/>

				<div className="editor-shell-body">
					{children}
				</div>

				{hasTraining && (
					<EditorFooter
						onDelete={onDelete}
						canDelete={canDelete}
						onCancel={onCancel}
						lastModifiedAt={lastModifiedAt}
						saving={savingTraining}
						onSaveAsTemplate={onSaveAsTemplate}
						onSave={onSave}
						canSave={canSave}
						mode={editorMode}
					/>
				)}
			</div>

			<SlideOver
				open={!!activePanel}
				onClose={() => setActivePanel(null)}
				title={PANEL_LABELS[activePanel] || ""}
			>
				{renderPanelContent()}
			</SlideOver>
		</div>
	);
}
